import * as React from "react";
import { SingleNavMenuLinkExternal as ISingleNavMenuLinkExternal } from "../../../pages/identity/useNavMenu";
import { getLocalToken } from "../../../services/cpln";
import { TOKEN_EXP_CHECK_INTERVAL_MS } from "../../../envVariables";
import { LinkOutlined } from "@ant-design/icons";
import { getMetricsUrl, getTracesUrl } from "../../../services/utils";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";

interface Props {
  link: ISingleNavMenuLinkExternal;
  index: number;
}
export const SingleNavMenuLinkExternal: React.FC<Props> = ({ link, index }) => {
  const org = useAppSelector(selectOrg);
  const grafanaEndpoint = useAppSelector((state) => state.discovery.endpoints.grafana);

  const formRef = React.useRef<HTMLFormElement>(null as any);
  const [token, setToken] = React.useState("");

  const action = `${grafanaEndpoint.replace("{org}", org)}/auth/process`;
  const inputs: { name: string; value: string }[] = [];

  if (link.type === "traces-org") {
    inputs.push({
      name: "redirect",
      value: getTracesUrl("org"),
    });
  }
  if (link.type === "metrics-org") {
    inputs.push({
      name: "redirect",
      value: getMetricsUrl("org"),
    });
  }
  if (link.type === "traces-gvc") {
    inputs.push({
      name: "redirect",
      value: getTracesUrl("gvc", {
        gvcName: window.location.pathname.split("/")[5],
      }),
    });
  }
  if (link.type === "metrics-gvc") {
    inputs.push({
      name: "redirect",
      value: getMetricsUrl("gvc", {
        gvcName: window.location.pathname.split("/")[5],
      }),
    });
  }
  if (link.type === "metrics-workload") {
    inputs.push({
      name: "redirect",
      value: getMetricsUrl("workload", {
        gvcName: window.location.pathname.split("/")[5],
        workloadName: window.location.pathname.split("/")[7],
      }),
    });
  }
  if (link.type === "traces-workload") {
    inputs.push({
      name: "redirect",
      value: getTracesUrl("workload", {
        gvcName: window.location.pathname.split("/")[5],
        workloadName: window.location.pathname.split("/")[7],
      }),
    });
  }
  if (link.type === "metrics-mk8s") {
    inputs.push({
      name: "redirect",
      value: getMetricsUrl("mk8s", {
        clusterAlias: link.clusterAlias,
        clusterName: link.clusterName,
      }),
    });
  }

  React.useEffect(() => {
    getLocalToken().then((res) => {
      if (res.accessToken !== "pass") {
        setToken(res.accessToken);
      }
    });
    const localTokenInterval = setInterval(() => {
      getLocalToken().then((res) => {
        if (res.accessToken !== "pass") {
          setToken(res.accessToken);
        }
      });
    }, TOKEN_EXP_CHECK_INTERVAL_MS);
    return () => {
      clearInterval(localTokenInterval);
    };
  }, []);

  return (
    <>
      <form className="hidden" ref={formRef} action={action} method="POST" target="_blank">
        {inputs.map((input) => (
          <input key={input.name} name={input.name} value={input.value} type="hidden" />
        ))}
        <input name="idToken" value={token} type="hidden" />
        <button type="submit">submit</button>
      </form>
      <a
        data-link-id={link.id}
        className={`new-nav-link-item px-2 py-1`}
        href={""}
        onClick={(e) => {
          e.preventDefault();
          if (formRef.current) {
            formRef.current.submit();
          }
        }}
        target={"_blank"}
      >
        <span className="mr-2">{link.label}</span>
        <LinkOutlined className="inline-block color-link" />
      </a>
    </>
  );
};
